
export function Loading(){
    return(
        <>
        {/* <div className="col-3 ">
        <div className="snippet " data-title="dot-pulse">
          <div className="stage ">
            <div className="dot-pulse "></div>
          </div>
        </div>
      </div> */}
<div className="flex items-center justify-center" >
<div className="loader">

</div>
</div>
        </>
    )
}